import { CheckIcon } from 'lucide-react';
import { Separator } from '~/components/ui/Separator';

export interface SetupStep {
  title: string;
  description: string;
  note?: string;
}

export interface SetupGuideData {
  prerequisites: string[];
  steps: SetupStep[];
}

interface ConnectorSetupGuideProps {
  setupGuide: SetupGuideData;
}

export default function ConnectorSetupGuide({
  setupGuide,
}: ConnectorSetupGuideProps) {
  return (
    <div className="pl-4 lg:pl-11 pr-2 pb-3 space-y-4">
      <div className="space-y-2">
        <h3 className="text-sm font-semibold flex items-center gap-2">
          <div className="size-6 rounded-full bg-primary/10 flex items-center justify-center text-primary text-xs font-bold">
            !
          </div>
          Prerequisites
        </h3>
        <ul className="space-y-2 ml-8">
          {setupGuide.prerequisites.map((prereq, index) => (
            <li
              key={index}
              className="text-sm text-muted-foreground flex items-start gap-2"
            >
              <CheckIcon className="size-4 mt-0.5 text-green-600 shrink-0" />
              <span>{prereq}</span>
            </li>
          ))}
        </ul>
      </div>

      <Separator />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold">Setup Steps</h3>
        <div className="space-y-3">
          {setupGuide.steps.map((step, index) => (
            <div key={index} className="flex gap-3">
              <div className="flex flex-col items-center">
                <div className="size-7 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold shrink-0">
                  {index + 1}
                </div>
                {index < setupGuide.steps.length - 1 && (
                  <div className="w-px h-full bg-border mt-2" />
                )}
              </div>
              <div className="flex-1 pb-3">
                <h4 className="text-sm font-medium mb-1">{step.title}</h4>
                <p className="text-xs text-muted-foreground mb-1 leading-relaxed">
                  {step.description}
                </p>
                {step.note && (
                  <p className="text-xs text-muted-foreground/70 italic leading-relaxed">
                    {step.note}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
